/* global window */
// import jwt_decode from "jwt-decode";
import moment from "moment";
import "moment-timezone";
import numeral from "numeral";
import * as Yup from "yup";
import { v4 as uuidv4 } from "uuid";
import {
  MARGIN_TYPE,
  WEIGHT_UNIT,
  PRODUCT_STATUS,
  PRODUCT_ONLINE_STATUS,
  PRODUCT_ONLINE_STATUS_EXPORT,
  PRODUCT_STATUS_EXPORT,
  WEIGHT_UNIT_EXPORT,
  MARGIN_TYPE_EXPORT,
  SALE_TAX_TYPE,
  BACKGROUND_TASK_KEYS,
  PAYMENT_TYPE_SALE_ORDER,
  CELERY_PROGRESS_STATUS_OBJECT,
  DISCOUNT_TYPE,
  SALE_RETURN_STATUS,
  salesOptionspaymentSubTypes,
  PAYMENT_STATUS,
  salesOptionspaymentSubTypesExtended,
  salesOptionsForChequepaymentSubTypes,
  dateFormat as _dateFormat,
  OVERDUE_PERIOD,
} from "./constants";
import toPath from "lodash-es/toPath";
import clone from "lodash-es/clone";
import { isObject } from "formik";
import { Tooltip, notification, Modal } from "antd";
import { SALE_DISCOUNT_TYPE } from "./constants";
import { SETTINGS } from "./defaultSettings";
import { FormattedMessage } from "react-intl";
import { InfoCircleOutlined } from "@ant-design/icons";
import { BACKGROUND_TASK_STATUS } from "./../../../constants/config";
import Decimal from "decimal.js";
import { cloneDeep } from "lodash";
const host = window.location.origin;
export const getUserId = () => {
  return localStorage.getItem(`${host}_accessToken`);
};

export const getDeliveryStopHistory = (stop) => {
  return Array.isArray(stop?.delivery_fulfilment_status_history)
    ? stop.delivery_fulfilment_status_history
    : Array.isArray(stop?.delivery_fulfillment_status_history)
      ? stop.delivery_fulfillment_status_history
      : [];
};

export const getLatestDeliveryStopHistory = (stop) => {
  const stopHistory = getDeliveryStopHistory(stop);
  return stopHistory.length ? stopHistory[stopHistory.length - 1] : null;
};

export const getDeliveryStopFulfillmentStatus = (stop) => {
  const latestStopHistory = getLatestDeliveryStopHistory(stop);
  return (
    latestStopHistory?.delivery_fulfilment_status ??
    latestStopHistory?.delivery_fulfillment_status ??
    stop?.sale_order?.delivery_fulfilment_status ??
    stop?.sale_order?.delivery_fulfillment_status
  );
};

export const applyPromotionAndTax = (products, setTaxValues) => {
  // Todo: setTaxValues has  not to take as argument in this function, consider  utility setTaxValues
  const updatedProduct = products.map((el) => {
    if (!el?.is_misc) {
      const { isPromotion, promotionApplied, promotionPrice, preferredPrice, isDirty } = getPromotionDetails(el, el.unit, el.quantity);
      const unitPrices = addPromotionKeys(cloneDeep(el.unit_prices), el.quantity);
      const updatedProduct = {
        ...el,
        newPrice: isDirty ? el?.newPrice : isPromotion && promotionApplied ? promotionPrice : preferredPrice,
        unit_prices: unitPrices,
      };
      const tax_values = setTaxValues({
        product_id: el.id,
        is_tax_applicable: el?.is_tax_applicable || false,
        quantity: el.quantity || 1,
        discount: el?.discount || 0,
        discount_type: el?.discount_type || SALE_DISCOUNT_TYPE.FIXED.value,
        lowest_unit_definition: el?.unit_prices?.[el?.unit]?.lowest_unit_definition,
        cost: el?.unit_prices?.[el?.unit]?.cost,
        price: updatedProduct.newPrice,
        entity_tax_values: el?.tax_values || [],
        tax_attributes: el?.tax_values[0]?.tax_attributes || {},
        tax_values: el.tax_values || [],
      });
      updatedProduct["tax_values"] = tax_values;
      return updatedProduct;
    } else {
      return {
        ...el,
      };
    }
  });
  return updatedProduct;
};
export const sameUPCArray = (prodEntity) => {
  if (prodEntity?.selected_unit_prices?.length > 1) {
    return true;
  }
  return false;
};

export const notificationAntd = (type, message, description, duration, placement = "bottomRight") => {
  const desc = Array.isArray(description) ? description.map((d) => "• " + d).join("\n") : description;
  notification[type]({ message, description: desc, duration, placement });
};
export function isCombinationValid(combination, attributeNames, attributeValues) {
  for (let combo of combination) {
    const attributeNameIndex = attributeNames.indexOf(combo.name);
    if (attributeNameIndex === -1) {
      return false; // attribute name not found
    }
    const validValues = attributeValues[attributeNameIndex];
    if (!validValues.includes(combo.value)) {
      return false; // attribute value not valid
    }
  }
  return true;
}
export const getPromotionDetails = (product, unit, quantity) => {
  if (!product?.unit_prices) {
    return {};
  }
  const isPromotion = product.unit_prices[unit].is_promotion;
  const minOrderQty = product.unit_prices[unit].min_order_qty;
  const promotionApplied = isPromotion && quantity >= minOrderQty;
  const promotionPrice = product.unit_prices[unit].promotion_price;
  const preferredPrice = product.unit_prices[unit].preferred_price;
  const isDirty = product.unit_prices[unit]?.isDirty;
  return {
    isPromotion,
    minOrderQty,
    promotionApplied,
    promotionPrice,
    preferredPrice,
    isDirty,
  };
};
export const setAccessToken = (token) => {
  window.localStorage[`${host}_accessToken`] = token;
};
export const setCurrency = (value) => {
  currency = value;
};
export let currency = "$";
export const setIdToken = (token) => {
  window.localStorage[`${host}_idToken`] = token;
};
export const dateToday = () => {
  return moment().format("MM/DD/YYYY");
};
export const dateFormat = "MM/DD/YYYY";
export const cartesianProduct = (...a) => {
  if (a.length === 1) {
    return a[0].map((e) => [e]); // Return an array of single-element arrays
  }
  return a.reduce((a, b) => a.flatMap((d) => b.map((e) => [d, e].flat())));
};
export const asterisk = (cost_price_gt_sale_price = false, curr_price_ne_sale_price = false) =>
  (cost_price_gt_sale_price ? <span style={{ color: "red" }}>**</span> : curr_price_ne_sale_price ? <span style={{ color: "red" }}>*</span>:"");
export const unSetSessionCookies = () => {
  localStorage.removeItem(`${host}_lastAuthCallTimeStamp`);
  localStorage.removeItem(`${host}_refreshTokenExpireTime`);
  localStorage.removeItem(`${host}_refreshToken`);
  localStorage.removeItem(`${host}_idToken`);
  localStorage.removeItem(`${host}_accessToken`);
  localStorage.removeItem(`${host}_role`);
  localStorage.removeItem(`${host}_username`);
};
function generateRandomFromString(pass, str) {
  pass.push(str[Math.floor(Math.random() * str.length)]);
}
export function envFlagToBool(value) {
  if (!value) return false;
  const normalized = value.trim().toLowerCase();
  return ["true", "1", "yes", "on"].includes(normalized);
}
export function envValueOrDefault(value, defaultValue = "") {
  if (!value) return defaultValue;

  return value.trim();
}
export function generatePass() {
  let pass = [];
  let capitalAlphasStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let smallAlphasStr = "abcdefghijklmnopqrstuvwxyz";
  let numbersStr = "0123456789";
  let spcialCharsStr = `!"#$%&'()*+,-./:;<=>?@[\]^_\`{|}~`;
  generateRandomFromString(pass, spcialCharsStr);
  for (let i = 0; i < 3; i++) {
    generateRandomFromString(pass, capitalAlphasStr);
    generateRandomFromString(pass, smallAlphasStr);
  }
  generateRandomFromString(pass, numbersStr);
  return pass.join("");
}
export const setLastAuthCallTimeStamp = (value) => {
  window.localStorage[`${host}_lastAuthCallTimeStamp`] = value;
};
export const setRefreshToken = (value) => {
  window.localStorage[`${host}_refreshToken`] = value;
};
//decode access token
export const getUserRole = () => {
  return localStorage.getItem(`${host}_role`);
};
export const USER_ROLE = localStorage.getItem(`${host}_role`);
export const genericStatusChecker = (localStorageKey, checkStatusFunction, reject, resolve) => {
  let completionStatuses = [CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.id, CELERY_PROGRESS_STATUS_OBJECT.FAILED.id];
  const checkStatus = () => {
    const customerExportId = localStorage.getItem(localStorageKey);
    if (customerExportId !== "null") {
      checkStatusFunction(customerExportId)
        .then((res) => {
          const { id, result, status: statusKey } = res.data.entity;
          if (completionStatuses.includes(statusKey)) {
            if (statusKey === CELERY_PROGRESS_STATUS_OBJECT.FAILED.id) {
              reject({ status: "Failed" });
            } else if (statusKey === CELERY_PROGRESS_STATUS_OBJECT.COMPLETED.id) {
              resolve(result);
            }
            localStorage.setItem(localStorageKey, "null");
          } else if (!completionStatuses.includes(statusKey)) {
            try {
              setTimeout(() => {
                checkStatus();
              }, 3000);
            } catch (error) {
              reject(error);
              localStorage.setItem(localStorageKey, "null");
            }
          }
        })
        .catch((err) => {
          reject(err);
          console.log(err);
        });
    }
  };
  // Start checking status
  checkStatus();
};
//
export function formatDate(date) {
  return moment(date).format("MM/DD/YYYY");
}
export function formatDateTime(dateTime, dateTimeFormat = "MM/DD/YYYY, h:mm:ss a") {
  return moment(dateTime).format(dateTimeFormat);
}
export function getTimeByTimeZoneForTime(timezone, dateTime, format = "YYYY-MM-DDTHH:mm:ss") {
  // debugger
  const localTime = getTimeByTimeZoneOnMoment(timezone, dateTime, format);
  if (!localTime) {
    return;
  }
  const convertedTimezone = formatDateTime(localTime, format);
  return convertedTimezone;
}
export function getTimeByTimeZone(timezone, dateTime, format = _dateFormat) {
  const localTime = getTimeByTimeZoneOnMoment(timezone, dateTime, format);
  if (!localTime) {
    return;
  }
  const convertedTimezone = formatDateTime(localTime, format);
  return convertedTimezone;
}
export function getTimeByTimeZoneOnMoment(timezone, dateTime, format = _dateFormat) {
  if (!timezone || !dateTime) {
    return;
  }
  return moment.utc(dateTime).tz(timezone.value).format(format);
}
export const dateStringApplyOffSet = (value, timeZone, dateTimeFormat = "MM/DD/YYYY") => {
  if (!value || value === "" || value === null) {
    const dateTime = getCurrentUtcDateTime(timeZone);
    value = moment(dateTime, "MM/DD/YYYY, hh:mm:ss A").format(dateTimeFormat);
  }
  if (!timeZone) {
    console.warn("dateStringApplyOffSet called without timezone");
    return moment(value).format(dateTimeFormat);
  }
  const hasTime = /\d{1,2}:\d{2}(:\d{2})?/.test(value); // Check if time part is present
  const dateInMilliSeconds = new Date(value).getTime();
  const timezoneOffset = moment.tz.zone(timeZone.value).utcOffset(dateInMilliSeconds);
  const adjustedDate = new Date(dateInMilliSeconds + timezoneOffset * 60 * 1000);
  // if (hasTime) {
  // Return full ISO without 'Z'
  return adjustedDate.toISOString().split("Z")[0];
  // } else {
  //   // Return date only (you can format as needed)
  //   return adjustedDate.toISOString().split("T")[0];
  // }
};
export const dateTimeStringApplyOffSet = (value, timeZone, dateTimeFormat = "YYYY-MM-DDTHH:mm:ss") => {
  if (!value || value === "" || value === null) {
    let dateTime = getCurrentUtcDateTime(timeZone);
    value = moment(dateTime, dateTimeFormat).format(dateTimeFormat);
  }
  const localTimeInTZ = moment.tz(value, dateTimeFormat, timeZone.value);
  const utcTime = localTimeInTZ.utc().format(dateTimeFormat);
  return utcTime;
};
// Convert current date to a given timezone.
export function getDateTimeInZone(timezoneObject, hoursToAdd = 0, minutesToAdd = 0) {
  if (!timezoneObject || !timezoneObject.value) {
    throw new Error("Invalid timezone object");
  }
  const date = new Date();
  // Convert to string parts in target timezone
  const options = {
    timeZone: timezoneObject.value,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  const parts = new Intl.DateTimeFormat("en-GB", options).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value.padStart(2, "0");
  let year = parseInt(get("year"));
  let month = parseInt(get("month"));
  let day = parseInt(get("day"));
  let hour = parseInt(get("hour"));
  let minute = parseInt(get("minute"));
  let second = parseInt(get("second"));
  // Add minutes
  minute += minutesToAdd;
  // Add hours
  hour += hoursToAdd;
  // Handle overflow (e.g., 75 mins => 1 hour 15 mins)
  const newDate = new Date(year, month - 1, day, hour, minute, second);
  // Format again
  const finalYear = newDate.getFullYear();
  const finalMonth = `${newDate.getMonth() + 1}`.padStart(2, "0");
  const finalDay = `${newDate.getDate()}`.padStart(2, "0");
  const finalHour = `${newDate.getHours()}`.padStart(2, "0");
  const finalMinute = `${newDate.getMinutes()}`.padStart(2, "0");
  const finalSecond = `${newDate.getSeconds()}`.padStart(2, "0");
  return `${finalYear}-${finalMonth}-${finalDay}T${finalHour}:${finalMinute}:${finalSecond}`;
}
export const addTime = (value, timeZone) => {
  try {
    if (!value.includes("T")) {
      return value + "T00:00:00.000";
    }
    // Check if the date string matches the full expected format
    const fullFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}$/;
    if (fullFormatRegex.test(value)) {
      return value;
    }
    // Check if the date string matches the format without milliseconds
    const noMillisecondsRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
    if (noMillisecondsRegex.test(value)) {
      return value + ".000";
    }
    // Check if the date string matches the date-only format
    const dateOnlyRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateOnlyRegex.test(value)) {
      return value + "T00:00:00.000";
    }
    // If none of the formats match, return an error message
    return "Invalid date format";
  } catch (error) {
    console.error("Error in dateStringApplyOffSetNew:", error);
    return null;
  }
};
export function parseFilename(filename) {
  // Split the filename into name and extension
  const dotIndex = filename.lastIndexOf(".");
  let name = dotIndex !== -1 ? filename.slice(0, dotIndex) : filename;
  let extension = dotIndex !== -1 ? filename.slice(dotIndex) : "";
  // Remove or replace problematic characters
  const sanitizedName = name
    .replace(/[^a-zA-Z0-9._-]/g, "_") // Replace invalid characters with underscores
    .replace(/\s+/g, "_") // Replace spaces with underscores
    .replace(/[()]/g, "") // Remove parentheses
    .replace(/_+$/, ""); // Remove trailing underscores
  return sanitizedName + extension;
}
export function formatCurrency(amount = 0) {
  return Number(numeral(amount).format("0.00"));
}

export function formatClassOfTrades(classOfTrades) {
  if (typeof classOfTrades !== "string") {
    return classOfTrades || "-";
  }

  const normalizedValue = classOfTrades.trim();
  if (!normalizedValue) {
    return "-";
  }

  return normalizedValue
    .toLowerCase()
    .replace(/(^|[\s-])([^\s-])/g, (_, separator, letter) => `${separator}${letter.toUpperCase()}`);
}

/** Symbol-aware money formatting: -$1,234.50 (negatives keep the leading minus). */
export function formatCurrencyWithSymbol(symbol, amount) {
  const n = Number(amount || 0);
  return `${n < 0 ? "-" : ""}${symbol || "$"}${numeral(Math.abs(n)).format("0,0.00")}`;
}
export function formatCurrencyCustom(amount) {
  return numeral(amount).format("0.00");
}
export function formatWithDeci(amount = 0) {
  const decimalAmount = new Decimal(amount);
  return decimalAmount.toFixed(2); // returns string with exactly 2 decimal places
}
export function formatCurrencyCustomThree(amount) {
  return numeral(amount).format("0.000");
}
export function formatAndShortCurrency(amount) {
  return numeral(amount).format("0.00 a");
}
export function randomNo() {
  const d = new Date();
  const sec = d.getTime();
  return +("" + sec).split("").slice(-4).join("");
}
export function formatAndShortNumber(number) {
  return numeral(number).format("a");
}
export function lstripZeros(string) {
  return string.replace(/^0+/, "");
}
export function sameUPCsInUnits(unitPrices, upc_sku = undefined) {
  if (!upc_sku) return [];
  const sameUPCObjects = {};
  upc_sku = lstripZeros(upc_sku);
  Object.values(unitPrices).forEach((item, key) => {
    if (sameUPCObjects[item.upc]) {
      sameUPCObjects[item.upc].push(item.unit);
    } else {
      sameUPCObjects[item.upc] = [item.unit]; // Accessing the 'upc' property of each object
    }
  });
  if (upc_sku && sameUPCObjects[upc_sku]?.length && sameUPCObjects[upc_sku]?.length > 1) {
    return sameUPCObjects;
  }
  return [];
}
export function formatNumericAmount(amount) {
  return Number(amount.toFixed(2));
}
export const _formatDate = (dateTimeString) => {
  if (dateTimeString?.toISOString) {
    const isoString = dateTimeString.toISOString();
    dateTimeString = isoString;
  }
  if (dateTimeString?.split && dateTimeString.split("").find((e) => e === "T")) {
    return dateTimeString.split("T")[0];
  }
  return dateTimeString;
};
export function showInProgressNotification() {
  return notification.info({
    message: "Bulk Uploading is in progress you can proceed with your other tasks",
    duration: 3,
  });
}
export function getWordCount(text) {
  if (!text) return 0;
  const words = text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0);
  return words.length;
}
//To Replace single searchKey to QueryParams for payload Search
export const REPLACE_TO_DEFAULT_QUERY_PARAMS = (queryParams, initialFilter) => {
  if (typeof queryParams !== "object") {
    let queryString = queryParams;
    queryParams = {};
    queryParams.search_key = queryString;
  }
  Object.keys(initialFilter).forEach(function (key) {
    if (queryParams[key] == null || queryParams[key] == undefined) {
      queryParams[key] = initialFilter[key];
    }
  });
  return queryParams;
};
// Pass constans object and will return CONSTANTS KEY based on value
export const getKey = (obj, lookUpValue) => {
  let key, value;
  for ([key, value] of Object.entries(obj)) {
    if (lookUpValue === value) return key;
  }
};
export const paymentDetail = (paymentTypeSaleOrder) => {
  return {
    cash: { amount: "", payment_type: paymentTypeSaleOrder.CASH || 1 },
    ach: {
      amount: "",
      payee: "",
      payer: "",
      payment_type: paymentTypeSaleOrder.ACH || PAYMENT_TYPE_SALE_ORDER.ACH.value,
    },
    on_account: { amount: "", payment_type: paymentTypeSaleOrder.ON_ACCOUNT || 6 },
    cash_on_delivery: { amount: "", payment_type: paymentTypeSaleOrder.CASH_ON_DELIVERY || 4 },
    credit_debit_card: {
      amount: "",
      name: "",
      payment_type: paymentTypeSaleOrder.CREDIT_DEBIT_CARD || 3,
    },
    cheque: {
      amount: "",
      check_no: "",
      check_acc_title: "7 Star Wholesale",
      check_date: null,
      reference_number: "",
      payment_type: paymentTypeSaleOrder.CHEQUE || 2,
    },
    zelle_wire_transfer: {
      amount: "",
      zelle_title: "",
      zelle_date: null,
      reference_number: "",
      payment_type: paymentTypeSaleOrder.ZELLE_WIRE_TRANSFER || 5,
    },
    BANK_TRANSFER_IBFT: {
      amount: "",
      reference_number: "",
      payment_type: paymentTypeSaleOrder?.BANK_TRANSFER_IBFT || 7,
    },
    Customer_Credit_Added: {
      amount: "",
      payment_type: paymentTypeSaleOrder?.CUSTOMER_CREDIT_ADDED || 9,
    },
  };
};
export const paymentTypes = () => {
  // converting object to object with key as value and value as key of PAYMENT_TYPE_SALE_ORDER
  const paymentTypes = {};
  Object.keys(PAYMENT_TYPE_SALE_ORDER).forEach((key) => {
    // CUSTOMER_CREDIT_USED and CUSTOMER_CREDIT_ADDED are not payment types but wallet 
    if(PAYMENT_TYPE_SALE_ORDER.CUSTOMER_CREDIT_USED.value === PAYMENT_TYPE_SALE_ORDER[key].value){
        return
    }
    paymentTypes[PAYMENT_TYPE_SALE_ORDER[key].value] = PAYMENT_TYPE_SALE_ORDER[key].type;
  })
  return paymentTypes
};
const staticCols = [
  undefined,
  "id",
  "name",
  "description",
  "cost",
  "margin",
  "margin_type",
  "sku",
  "min_qty",
  "max_qty",
  "upc",
  "mlc",
  "bin",
  "gtn",
  "is_online",
  "status",
  "weight",
  "weight_unit",
  "brand_id",
  "brand_name",
  "category_ids",
  "category_names",
  "tag_values",
  "supplier_ids",
];
export const parseExcelRow = (cols, values) => {
  let object = {};
  for (let index = 1; index <= 23; index++) {
    object[staticCols[index]] = values[index] ? values[index] : null;
  }
  object["qty_in_hand"] = {};
  for (let index = 24; index < cols.length; index++) {
    object["qty_in_hand"][cols[index]] = values[index] ? values[index] : 0;
  }
  object.is_online = object.is_online ? PRODUCT_ONLINE_STATUS[object.is_online] : null;
  object.status = object.status ? PRODUCT_STATUS[object.status] : null;
  object.margin_type = object.margin_type ? MARGIN_TYPE[object.margin_type] : null;
  object.weight_unit = object.weight_unit ? WEIGHT_UNIT[object.weight_unit] : null;
  return object;
};
export const loadMoneyKitScript = () => {
  const currentHost = window.location.host;
  const src =
    !currentHost.includes("app.ikhub.biz") && !currentHost.includes("appp.ikhub.biz")
      ? "https://bank-link-widget-sandbox.grailpay.com/sdk.js"
      : "https://bank-link-widget.grailpay.com/sdk.js";
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error for ${src}`));
    document.body.appendChild(script);
  });
};
export const parseRowForExcel = (row) => {
  let object = Object.assign({}, row);
  object.is_online = PRODUCT_ONLINE_STATUS_EXPORT[object.is_online];
  object.status = PRODUCT_STATUS_EXPORT[object.status];
  object.margin_type = MARGIN_TYPE_EXPORT[object.margin_type];
  object.weight_unit = WEIGHT_UNIT_EXPORT[object.weight_unit];
  return object;
};
export const parseSpecialChr = (dist_name) => {
  let specialCharsRegex = /[^a-z0-9-()]/gi;
  const name = dist_name?.toString() || "dist_name";
  return name.replace(specialCharsRegex, "-").replace(/\(/g, "-").replace(/\)/g, "-");
};
export const fileNameDetector = (url) => {
  const pathname = new URL(url)?.pathname;
  const filename = pathname.split("/").pop();
  const DISPLAY_FILE_NAME_LIMIT = 20;
  return filename.slice(0, DISPLAY_FILE_NAME_LIMIT);
};
// Returns the fetch promise so callers can react to a failure (an S3 object whose CORS
// rules block the read, say) instead of the download silently doing nothing.
// no-store: an <img> of the same S3 URL caches a response without CORS headers, which would fail this read.
export const handleDownload = (url, filename = "liscence-certificate") => {
  return fetch(url, { cache: "no-store" })
    .then((response) => response.blob())
    .then((blob) => {
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = filename;
      link.click();
    });
};
export const openInNewTab = (url) => {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  anchor.click();
};
export const youtubeLinkIdParser = (url) => {
  var i,
    r,
    rx = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
  r = url.match(rx);
  return r != null ? r[1] : false;
};
export const preventEnterActions = (e) => {
  // Allow Enter to insert a newline inside textareas; only block it for
  // other fields (e.g. inputs) so it doesn't accidentally submit the form.
  if (e.key === "Enter" && e.target?.tagName !== "TEXTAREA") {
    e.preventDefault();
  }
};
export const VALIDATION_MESSAGE = (name) => {
  return `${name} is not valid`;
};
export const IS_REQUIRED_MESSAGE = (str) => {
  return `${str} is required`;
};
export const LEN_MESSAGE = (len, maxmin) => {
  if (maxmin === "max") {
    return `Max ${len} characters`;
  } else if (maxmin === "min") {
    return `Min ${len} characters`;
  }
};
export const MAX_MESSAGE = (name, size) => {
  return `${name} cannot be greater than ${size} character`;
};
export const MIN_MESSAGE = (name, size) => {
  return `${name} cannot be less than ${size} character`;
};
export const getSettingKey = (settings, parent, child = undefined) => {
  try {
    let resVal = settings || SETTINGS;
    if (child) {
      if (resVal[parent]?.hasOwnProperty && resVal[parent]?.hasOwnProperty(child)) {
        resVal = resVal[parent][child];
      } else {
        resVal = SETTINGS[parent][child];
      }
    } else {
      resVal = resVal[parent];
      if (!resVal || (Object.keys(resVal).length === 0 && resVal.constructor === Object && resVal !== false)) {
        resVal = SETTINGS[parent];
      }
    }
    return resVal;
  } catch (error) {
    console.log("error", error);
    return "";
  }
};
export const getCurrentUtcDateTime = (timezone) => {
  if (!timezone?.value) {
    return moment();
  }
  const momentDateTime = moment().tz(timezone?.value);
  return momentDateTime;
};
export const getCustomAttributeError = (errors, attributeType, index, groupIndex, label) => {
  if (errors[attributeType]) {
    if (attributeType === "attributes" && errors[attributeType][index]) {
      return `${label} ${errors[attributeType][index]["values"]}`;
    } else if (attributeType === "attribute_groups" && errors[attributeType][groupIndex] && errors[attributeType][groupIndex]["attributes"][index]) {
      return `${label} ${errors[attributeType][groupIndex]["attributes"][index]["values"]}`;
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export const OnEnter = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
  }
};
export const getUniqueNumber = (str) => {
  return str + new Date().valueOf();
};
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
export function toFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
export function moveIntoObject(obj, key) {
  let p = 0;
  var path = toPath(key);
  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }
  return obj;
}
export function getPath(key, obj) {
  var resVal = clone(obj);
  let pathArray = toPath(key);
  let isValid;
  if (Object.keys(resVal).length) {
    if (pathArray.length === 1) {
      isValid = obj[pathArray[0]];
    } else {
      for (var i = 0; i < pathArray.length; i++) {
        var currentPath = pathArray[i];
        var currentObj = moveIntoObject(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
          resVal = resVal[currentPath] = clone(currentObj);
        } else {
          isValid = currentObj;
        }
      }
    }
  }
  return isValid;
}
export function TextError(props) {
  return (
    <>
      <small style={props?.style || {}} className="text-danger">
        {props.children}
      </small>
      <br />
    </>
  );
}
export const requiredLabel = (label) => (
  <>
    {label}
    <span className="text-danger ml-1">*</span>
  </>
);
export function CancelBackgroundTask({ title, className, taskName, authState, customChanges, status }) {
  return (
    <button
      className={`btn ${className}  ${
        [null, "null", ""].includes(localStorage.getItem(BACKGROUND_TASK_KEYS[taskName].key)) || ["SUCCESS", "COMPLETED", "FAILURE"].includes(status)
          ? "btn-disabled-custom "
          : "btn-danger "
      }`}
      disabled={[null, "null", ""].includes(localStorage.getItem(BACKGROUND_TASK_KEYS[taskName].key)) || ["SUCCESS", "COMPLETED", "FAILURE"].includes(status)}
      onClick={() => {
        try {
          cancelBackgroundRequest(localStorage.getItem(BACKGROUND_TASK_KEYS[taskName].key), authState, taskName, customChanges);
        } catch (err) {}
      }}
    >
      {title}
    </button>
  );
}
export function cancelBackgroundRequest(current_task_id, { authToken }, taskName, customChanges) {
  fetch(`${BACKGROUND_TASK_STATUS}/${current_task_id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      localStorage.setItem(BACKGROUND_TASK_KEYS[taskName].key, "null");
      customChanges();
      notification.success({
        message: `${BACKGROUND_TASK_KEYS[taskName].title} has been cancelled successfully`,
        duration: 3,
      });
    })
    .catch((err) => {
      console.log("🚀 ~ file: utils.js:440 ~ cancelBackgroundRequest ~ err:", err.response.data.status);
    });
}
export function calculateDiscount(_amount, discountType, discount, qty = 1, charge_type, tax_values = []) {
  let amountAfterDiscount = 0;
  let totalAmount = 0;
  let discountAmount = 0;
  let amount = charge_type && charge_type === 2 ? -_amount : _amount;
  if (discountType == SALE_DISCOUNT_TYPE.PERCENTAGE.value) {
    totalAmount = amount * qty;
    discountAmount = totalAmount * (discount / 100);
    amountAfterDiscount = totalAmount - discountAmount;
  } else {
    amountAfterDiscount = (amount - discount) * qty;
    discountAmount = discount * qty;
  }
  if (tax_values?.length && qty) {
    amountAfterDiscount =
      amountAfterDiscount + tax_values.map(({ calculatedTax }) => calculatedTax).reduce((total, calculatedTax) => total + calculatedTax * 1, 0);
  }
  return amountAfterDiscount;
}
export function taxCalculate(amount, discountType, discount, qty = 1) {
  let amountAfterDiscount = 0;
  let totalAmount = 0;
  let discountAmount = 0;
  if (discountType == SALE_TAX_TYPE.PERCENTAGE.value) {
    totalAmount = amount * qty;
    discountAmount = totalAmount * (discount / 100);
    amountAfterDiscount = totalAmount - discountAmount;
  } else {
    amountAfterDiscount = (amount - discount) * qty;
    discountAmount = discount * qty;
  }
  return Math.abs(discountAmount);
}
const calculateTaxTotal = (tax_values = []) => {
  if (tax_values?.length > 0) {
    return tax_values.reduce((total, ele) => total + ele.value * 1, 0);
  }
  return 0;
};
export function calculateSubTotal(products) {
  let subTotal = 0;
  products.map((prod) => {
    subTotal += calculateDiscount(prod.newPrice, prod.discount_type, prod.discount, prod.quantity, prod.charge_type);
    // subTotal += calculateTaxTotal(prod.tax_values)
  });
  return subTotal;
}
export function calculateSaleDiscount(products, discount, discountType) {
  let subTotal = 0;
  let amountAfterDiscount = 0;
  products.map((prod) => {
    subTotal += calculateDiscount(prod.newPrice || prod?.unit_price, prod.discount_type, prod.discount, prod.quantity || prod?.qty);
  });
  amountAfterDiscount = calculateDiscount(subTotal, discountType, discount);
  amountAfterDiscount = subTotal - amountAfterDiscount;
  return amountAfterDiscount > 0 ? amountAfterDiscount : 0;
}
export function calculateSaleDiscountAfterTax(products, discount, discountType, totalTax) {
  let subTotal = 0;
  let discountAfterTax = 0;
  products.map((prod) => {
    subTotal += calculateDiscount(prod.newPrice || prod?.unit_price, prod.discount_type, prod.discount, prod.quantity || prod?.qty);
  });
  if (discountType == DISCOUNT_TYPE.FIXED) {
    discountAfterTax = discount * 1;
    // discountAfterTax = (subTotal + (totalTax * 1)) - (discount * 1)
  } else {
    discountAfterTax = (subTotal + totalTax * 1) * ((discount * 1) / 100);
  }
  return discountAfterTax > 0 ? discountAfterTax : 0;
}
export function calculateTotalProductDiscount(products) {
  let totalDiscount = 0;
  let discountAmount = 0;
  for (let i = 0; i < products.length; i++) {
    if (products[i].discount_type === 1) {
      discountAmount = products[i].newPrice * (products[i].discount / 100) * products[i].quantity;
      totalDiscount += discountAmount;
    } else {
      discountAmount = products[i].discount * products[i].quantity;
      totalDiscount += discountAmount;
    }
  }
  return totalDiscount;
}
export const CONSTANT_ATTRIBUTE = {
  SALE_PRICE: "sale price",
  COST_PRICE: "net cost price",
  BASE_COST_PRICE: "base cost price",
};
export const FromSlugFormatchingApi = {
  getOrderByIdApi: "getOrderByIdApi",
};
export function customRound(value) {
  // Extract the decimal part
  const decimalPart = value % 1;
  // If the decimal part is greater than or equal to 0.05, round to the nearest integer
  if (decimalPart >= 0.05) {
    return Math.round(value);
  } else {
    // Otherwise, return the value rounded to 2 decimal places
    return value.toFixed(2);
  }
}
export const getAttributeAbreviation = (attributeId, taxAttributes) => {
  let foundedAttribute = taxAttributes.find(({ id }) => id == attributeId);
  return foundedAttribute?.abbreviation || foundedAttribute?.name;
};
export const getTaxLocationForCustomer = (shipping_detail, customer_shipping_details) => {
  let tempLocations = {};
  if (shipping_detail?.state) {
    tempLocations["taxable_state"] = shipping_detail.state;
    if (shipping_detail?.county) {
      tempLocations["taxable_county"] = shipping_detail.county;
    }
    if (shipping_detail?.city) {
      tempLocations["taxable_city"] = shipping_detail.city;
    }
  } else if (customer_shipping_details?.state) {
    tempLocations["taxable_state"] = customer_shipping_details.state;
    if (customer_shipping_details?.county) {
      tempLocations["taxable_county"] = customer_shipping_details.county;
    }
    if (customer_shipping_details?.city) {
      tempLocations["taxable_city"] = customer_shipping_details.city;
    }
  }
  return tempLocations;
};
export const calculatedTaxForParticularProduct = ({
  cost,
  price,
  lowest_unit_definition,
  discount,
  discount_type,
  quantity,
  taxAttributes,
  tax_attributes,
  tax_attribute_id,
  customValueForAttributeId,
  field,
  value,
}) => {
  let taxAttributeValue = taxAttributes.filter(({ id }) => id == (field == "tax_attribute_id" ? customValueForAttributeId : tax_attribute_id));
  let tempSalePriceAsCompareToDiscount = 1;
  let taxAttribute;
  let tempValue = value;
  if (taxAttributeValue[0].name?.toLowerCase() == CONSTANT_ATTRIBUTE.SALE_PRICE) {
    lowest_unit_definition = 1;
    tempValue = tempValue / 100;
    taxAttribute = 1;
    let tempDiscount = discount;
    if (discount_type == DISCOUNT_TYPE.PERCENTAGE) {
      tempDiscount = (price * discount) / 100;
    }
    tempSalePriceAsCompareToDiscount = price - tempDiscount;
  } else if (taxAttributeValue[0].name?.toLowerCase() == CONSTANT_ATTRIBUTE.COST_PRICE) {
    lowest_unit_definition = 1;
    taxAttribute = cost;
    tempValue = tempValue / 100;
  }
  if (!taxAttribute) {
    taxAttribute = tax_attributes[field == "tax_attribute_id" ? customValueForAttributeId : tax_attribute_id];
  }
  return lowest_unit_definition * quantity * tempValue * (taxAttribute || 1) * tempSalePriceAsCompareToDiscount;
};
export const calculateTaxOnHandleChangeInTheCart = ({
  tax_attribute_id,
  taxAttributes,
  tax_attributes,
  price,
  discount,
  discount_type,
  cost,
  lowest_unit_definition,
  quantity,
  value,
}) => {
  let taxAttributeValue = taxAttributes.filter(({ id }) => id == tax_attribute_id);
  let tempSalePriceAsCompareToDiscount = 1;
  let taxAttribute;
  let tempValue = value;
  if (taxAttributeValue[0].name?.toLowerCase() == CONSTANT_ATTRIBUTE.SALE_PRICE) {
    lowest_unit_definition = 1;
    tempValue = tempValue / 100;
    taxAttribute = 1;
    let tempDiscount = discount;
    if (discount_type == DISCOUNT_TYPE.PERCENTAGE) {
      tempDiscount = (price * discount) / 100;
    }
    tempSalePriceAsCompareToDiscount = price - tempDiscount;
  } else if (taxAttributeValue[0].name?.toLowerCase() == CONSTANT_ATTRIBUTE.COST_PRICE) {
    lowest_unit_definition = 1;
    tempValue = tempValue / 100;
    taxAttribute = cost;
  }
  if (!taxAttribute) {
    taxAttribute = tax_attributes[tax_attribute_id];
  }
  return lowest_unit_definition * quantity * tempValue * (taxAttribute || 1) * tempSalePriceAsCompareToDiscount;
};
//TODO: Need to change order total discount and other functions
export function calculateSaleTotal(products = [], discount = 0, discountType, deliveryCharges = 0, coupon = undefined, saleType) {
  let subTotal = 0;
  let total = 0;
  let couponDiscount = 0;
  products.map((prod) => {
    subTotal += calculateDiscount(prod.newPrice, prod.discount_type, prod.discount, prod.quantity, prod.charge_type, prod.tax_values);
  });
  total = subTotal;
  if (discount > 0) {
    total = calculateDiscount(subTotal, discountType, discount);
  }
  // TODO: Future requirement
  if (coupon?.discount) {
    couponDiscount = calculateDiscount(total, coupon.type, coupon.discount);
    total -= subTotal - couponDiscount;
  }
  if (saleType) {
    total += deliveryCharges;
  }
  return total;
}
const convertToNumber = (value) => Number(value * 1);
export function calculateGrandTotal(
  products = [],
  discount = 0,
  discountType,
  taxObj = undefined,
  deliveryCharges = 0,
  coupon = undefined,
  saleType,
  grandTaxTotal,
  apply_additional_discount_before_tax
) {
  let subTotal = 0;
  let total = 0;
  let couponDiscount = 0;
  products.map((prod) => {
    subTotal += calculateDiscount(prod.newPrice, prod.discount_type, prod.discount, prod.quantity, prod.charge_type, []);
  });
  total = subTotal;
  if (apply_additional_discount_before_tax) {
    total = calculateDiscount(subTotal, discountType, discount || 0);
    total += grandTaxTotal;
  } else {
    total += grandTaxTotal;
    total = calculateDiscount(total, discountType, discount || 0);
  }
  if (saleType) {
    total += deliveryCharges;
  }
  return convertToNumber(total);
}
export const removeNullOrEmptyProperties = (obj) => {
  const newObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === "object") {
        // Recursively process nested objects
        const nestedObj = removeNullOrEmptyProperties(obj[key]);
        if (Object.keys(nestedObj).length > 0) {
          newObj[key] = nestedObj;
        }
      } else if (obj[key] !== null && obj[key] !== "") {
        newObj[key] = obj[key];
      }
    }
  }
  return newObj;
};
export function calculateTax(products, tax, tax_type = undefined, values = {}) {
  if (!!tax_type && tax_type == 2) {
    return tax;
  }
  let subTotal = calculateSubTotal(products);
  let discount = 0;
  try {
    discount = calculateSaleDiscount(values?.sale_order_details, values?.discount, values?.discount_type) || 0;
  } catch (error) {
    console.log(error);
  }
  return (subTotal - Number(discount)) * (tax / 100);
}
export function calculateMargin(cosT, pricE, marginType) {
  let cost = Number(cosT);
  let price = Number(pricE);
  let margin = 0;
  if (marginType == 1) {
    margin = price - cost;
  } else if (marginType == 2) {
    margin = ((price - cost) / price) * 100;
  }
  return formatCurrencyCustom(margin);
}

export function calculateReceiveProductMargin(cost, price, marginType) {
  return Number(price) > 0 ? calculateMargin(cost, price, marginType) : Number(0);
}

export function calculatePrice(cosT, margiN, marginType) {
  let cost = Number(cosT);
  let margin = Number(margiN);
  let price = 0;
  if (!cost) {
    return 0;
  }
  if (marginType == 1) {
    price = cost + margin;
  } else if (marginType == 2) {
    price = cost / (1 - (margin/100))
  }
  return formatCurrencyCustom(price);
}
export function calculateCost(pricE, margiN, marginType) {
  let margin = Number(margiN);
  let price = Number(pricE);
  let cost = 0;
  if (!price) {
    return 0;
  }
  if (marginType == 1) {
    cost = price - margin;
  } else if (marginType == 2) {
    cost = price * (1 - (margin/100))
  }
  return formatCurrencyCustom(cost);
}
// return bootstrap border error classes on the base of touched and errors
export function getErrorClasses(touched, errors, length) {
  let classes = "";
  if (Object.keys({ ...touched }).length >= length && Object.keys({ ...errors }).length >= length) {
    classes = "border border-danger";
  }
  return classes;
}
export function getObjectValue(list, key) {
  let type = "";
  for (let i = 0; i < list.length; i++) {
    if (list[i].value == key) {
      type = list[i].type;
      break;
    }
  }
  return type;
}
export function getValue(obj, key) {
  let a = Object.keys(obj).map((item) => {
    return obj[item].value === key ? obj[item].type : "";
  });
  return a.filter((el) => el);
}
export function compareValue(obj, value) {
  return Object.keys(obj).findIndex((item) => {
    return obj[item].value === value;
  });
}
export function conditionallyRender(condition, alternateText) {
  return condition ? condition : alternateText;
}
export const mapErrors = (errors) => {
  return errors.map((error) => notification.error({ message: error, duration: 5 }));
};
export const getRandomColor = () => {
  const colors = ["magenta", "red", "volcano", "orange", "gold", "lime", "green", "cyan", "blue", "geekblue", "purple"];
  return colors[Math.floor(Math.random() * colors.length)];
};
export const edit = {
  is_edit: false,
};
export const setEdit = (isEdit) => {
  edit.is_edit = isEdit;
};
export const date = () => {
  let yourDate = new Date();
  return yourDate.toISOString().split("T")[0];
};
export const customTotal = (from, to, size, name) => (
  <span className="react-bootstrap-table-pagination-total">
    <FormattedMessage id="Showing" defaultMessage="Showing" /> {name} {from} to {to} of {size}
  </span>
);
export const serialGenerator = (length = 5, startWith = "empty") => {
  var result = "";
  var characters = "ABCDEFGHIJKL0123456789MNOPQRSTUVWXY0123456789Zabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  let yourDate = new Date();
  let minDate = yourDate.toISOString().split("T")[0];
  return `${startWith}-${minDate.split("-").join("").slice(2, 8)}-${result}`;
};
export const findordertype = (n, order_types) => {
  let obj = order_types.find((el) => el.value == n);
  return obj;
};
export const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};
export function removeCSSClass(ele, cls) {
  const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
  ele.className = ele.className.replace(reg, " ");
}
export function addCSSClass(ele, cls) {
  ele.classList.add(cls);
}
export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;
// `notificationProps` is spread into each notification (e.g. a zIndex to show above a drawer).
export function handleApiErrorResponse(err, notificationProps = {}) {
  // User cancelled the "payment is in a deposit" confirm — not an error, show nothing.
  if (err?.__depositVoidCancelled) {
    return;
  }
  if (err?.response?.data?.errors?.length) {
    err.response.data.errors?.map((message) => notification.error({ message, ...notificationProps }));
  } else {
    console.log("🚀 ~ handleApiErrorResponse ~ err:", err);
    notification.error({ message: "Error occured", ...notificationProps });
  }
}
export const getSaleReturnStatusType = (value) => {
  const status = Object.values(SALE_RETURN_STATUS).find((status) => status.value === value);
  return status ? status.type : "N/A";
};
export const isValidDecimalFormat = (value) => {
  const regex = /^\d+(\.\d{0,2})?$/;
  return regex.test(value);
};
export const validDecimalFormat = (value) => {
  try {
    if (!value) {
      return 0; // or return null or any other default value based on your needs
    }
    const parts = value.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] ? parts[1].slice(0, 2) : "00";
    return Number(`${integerPart}.${decimalPart}`);
  } catch (error) {
    console.error("Error formatting decimal:", error);
    return 0; // or return null or any other default value based on your needs
  }
};
// Sort Objects and Products for Purchase Order Module
export function sortCategoriesObjectKeysAlphabatically(obj) {
  return Object.keys(obj).sort((a, b) => {
    const nameA = a ? a.toUpperCase() : "";
    const nameB = b ? b.toUpperCase() : "";
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
}
export function sortProductsAlphabatically(products) {
  return products.sort((a, b) => {
    const nameA = (a.product?.main_category?.name || a.product?.main_category_name || "").toUpperCase() + (a.product?.name?.toUpperCase() || "");
    const nameB = (b.product?.main_category?.name || b.product?.main_category_name || "").toUpperCase() + (b.product?.name?.toUpperCase() || "");
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
}
// Validation schema
export const COST_SCHEMA = Yup.object().shape({
  cart: Yup.array().of(
    Yup.object().shape({
      base_cost: Yup.number()
        .positive("Only Positive numbers")
        .min(0.1, "Supply Price cannot be 0 or less than 0")
        .max(999999999999999999, LEN_MESSAGE(999999999999999999, "max"))
        .required(IS_REQUIRED_MESSAGE("Supply Price")),
      quantity: Yup.number()
        .positive("Only Positive numbers")
        .min(1, "Qty cannot be 0 or less than 0")
        .max(999999999999999999, LEN_MESSAGE(999999999999999999, "max"))
        .required(IS_REQUIRED_MESSAGE("QTY")),
    })
  ),
});
export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const getPaymentSubTypeLabel = (subTypeValue) => {
  const allSubTypes = {
    ...salesOptionspaymentSubTypesExtended,
    ...salesOptionsForChequepaymentSubTypes,
  };
  const subType = Object.keys(allSubTypes).find((key) => allSubTypes[key].value === subTypeValue);
  return subType ? allSubTypes[subType].label : "";
};
export const getPaymentStatusName = (statusValue) => {
  const status = Object.keys(PAYMENT_STATUS).find((key) => PAYMENT_STATUS[key].value === statusValue);
  return status ? PAYMENT_STATUS[status].name : "Unknown";
};
export function getSalesRepName(user, placeholder) {
  return user?.username || placeholder;
}
export const getScrollXValue = (length) => {
  if (length <= 5) return "calc(0px + 100%)";
  const baseValue = 300;
  const incrementPerLength = 500;
  const n = Math.ceil((length - 3) / 3);
  const scrollValue = baseValue + (n - 1) * incrementPerLength;
  return `calc(${scrollValue}px + 100%)`;
};
export const renderColumnsWithTooltip = (columns) => {
  return columns.map((column) => ({
    ...column,
    title: (
      <span>
        {column.title}
        {column.tooltip && (
          <Tooltip title={column.tooltip} placement="top" overlayInnerStyle={{ backgroundColor: "#f0f0f0", color: "#000" }}>
            <InfoCircleOutlined style={{ marginLeft: 8, cursor: "pointer" }} />
          </Tooltip>
        )}
      </span>
    ),
  }));
};
export const handleNumericInput = (value) => {
  const numericValue = value.replace(/^(\d*\.?\d{0,2}).*/g, "$1");
  return numericValue;
};
export const displayValue = (minPayment, maxPayment) => {
  const min = minPayment || 0;
  const max = maxPayment || "Any";
  return `${min} - ${max}`;
};
export const addPromotionKeys = (unitPrices, qty, reset = false, resetDirty = false, resumeUnitPrices = null) => {
  if (reset) {
    if (unitPrices["1"]) {
      unitPrices["1"].is_promotion = false;
      unitPrices["1"].promotion_applied = false;
    }
    if (unitPrices["2"]) {
      unitPrices["2"].is_promotion = false;
      unitPrices["2"].promotion_applied = false;
    }
    if (unitPrices["3"]) {
      unitPrices["3"].is_promotion = false;
      unitPrices["3"].promotion_applied = false;
    }
    if (unitPrices["4"]) {
      unitPrices["4"].is_promotion = false;
      unitPrices["4"].promotion_applied = false;
    }
  } else {
    if (unitPrices["1"]) {
      unitPrices["1"].promotion_applied = unitPrices["1"]?.is_promotion && qty >= unitPrices["1"]?.min_order_qty ? true : false;
    }
    if (unitPrices["2"]) {
      unitPrices["2"].promotion_applied = unitPrices["2"]?.is_promotion && qty >= unitPrices["2"]?.min_order_qty ? true : false;
    }
    if (unitPrices["3"]) {
      unitPrices["3"].promotion_applied = unitPrices["3"]?.is_promotion && qty >= unitPrices["3"]?.min_order_qty ? true : false;
    }
    if (unitPrices["4"]) {
      unitPrices["4"].promotion_applied = unitPrices["4"]?.is_promotion && qty >= unitPrices["4"]?.min_order_qty ? true : false;
    }
  }
  if (resetDirty) {
    if (unitPrices["1"]) {
      unitPrices["1"].isDirty = false;
    }
    if (unitPrices["2"]) {
      unitPrices["2"].isDirty = false;
    }
    if (unitPrices["3"]) {
      unitPrices["3"].isDirty = false;
    }
    if (unitPrices["4"]) {
      unitPrices["4"].isDirty = false;
    }
  } else if (!resetDirty && resumeUnitPrices) {
    if (unitPrices["1"] && resumeUnitPrices["1"]) {
      unitPrices["1"].isDirty = resumeUnitPrices["1"].isDirty;
    }
    if (unitPrices["2"] && resumeUnitPrices["2"]) {
      unitPrices["2"].isDirty = resumeUnitPrices["2"].isDirty;
    }
    if (unitPrices["3"] && resumeUnitPrices["3"]) {
      unitPrices["3"].isDirty = resumeUnitPrices["3"].isDirty;
    }
    if (unitPrices["4"] && resumeUnitPrices["4"]) {
      unitPrices["4"].isDirty = resumeUnitPrices["4"].isDirty;
    }
  }
  // }
  return unitPrices;
};
export const shippingOptions = [
  {
    value: 1,
    label: <FormattedMessage id="Pick up" defaultMessage="Pick up" />,
  },
  {
    value: 2,
    label: <FormattedMessage id="Delivery" defaultMessage="Delivery" />,
  },
  {
    value: 3,
    label: <FormattedMessage id="Drop off" defaultMessage="Drop off" />,
  },
];
export const getShippingLabel = (value) => {
  const option = shippingOptions.find((option) => option.value === value);
  return option ? option.label : null; // return null or a default message if not found
};
export const isDateRangeWithin90Days = (startDate, endDate) => {
  if (!startDate || !endDate) return false;
  const diff = endDate.diff(startDate, "days");
  return diff <= 90;
};
export const formatCustomCommissionCriteriaValues = (values, keys) =>
  keys
    .map((key) => values[key])
    .filter((value) => value !== "")
    .join(",");
export const LOCAL_STORAGE_KEY_RATES = "commissionRates";
export const LOCAL_STORAGE_KEY_CRITERIA = "commissionCriteria";
export const customCommissionCriteriavalidationSchema = Yup.object().shape({
  commission_custom_rate_1: Yup.string().test("commission_custom_rate_1", "Criteria 1 is required if commission rate 1 is filled", function (value) {
    const { commission_custom_rate_criteria_1 } = this.parent;
    return !value || !!commission_custom_rate_criteria_1;
  }),
  commission_custom_rate_criteria_1: Yup.string().test(
    "commission_custom_rate_criteria_1",
    "Commission rate 1 is required if criteria 1 is filled",
    function (value) {
      const { commission_custom_rate_1 } = this.parent;
      return !value || !!commission_custom_rate_1;
    }
  ),
  commission_custom_rate_2: Yup.string().test("commission_custom_rate_2", "Criteria 2 is required if commission rate 2 is filled", function (value) {
    const { commission_custom_rate_criteria_2 } = this.parent;
    return !value || !!commission_custom_rate_criteria_2;
  }),
  commission_custom_rate_criteria_2: Yup.string().test(
    "commission_custom_rate_criteria_2",
    "Commission rate 2 is required if criteria 2 is filled",
    function (value) {
      const { commission_custom_rate_2 } = this.parent;
      return !value || !!commission_custom_rate_2;
    }
  ),
  commission_custom_rate_3: Yup.string().test("commission_custom_rate_3", "Criteria 3 is required if commission rate 3 is filled", function (value) {
    const { commission_custom_rate_criteria_3 } = this.parent;
    return !value || !!commission_custom_rate_criteria_3;
  }),
  commission_custom_rate_criteria_3: Yup.string().test(
    "commission_custom_rate_criteria_3",
    "Commission rate 3 is required if criteria 3 is filled",
    function (value) {
      const { commission_custom_rate_3 } = this.parent;
      return !value || !!commission_custom_rate_3;
    }
  ),
});
export const backToPurchaseOrder = (isNavigatingRef, history, module) => {
  isNavigatingRef.current = true;
  if (module == "purchase_order") {
    history.push("/inventory/purchase/orders");
  } else if (module == "po_return") {
    history.push("/inventory/purchase/returns");
  } else if (module == "po_receive") {
    history.push("/inventory/purchase/receives");
  }
};
const LeaveConfirmIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="11" fill="var(--primary-color, #ea1e51)" />
    <rect x="9.9" y="5.5" width="2.2" height="7.7" rx="1.1" fill="#fff" />
    <circle cx="11" cy="16.2" r="1.3" fill="#fff" />
  </svg>
);

export const confirmationModal = (isNavigatingRef, history, module) => {
  Modal.confirm({
    className: "po-leave-confirm-modal",
    icon: <LeaveConfirmIcon />,
    title: <span className="text-regular grey-900">Are you sure you want to leave this page?</span>,
    style: { maxWidth: "480px", width: "480px" },
    bodyStyle: { padding: "20px" },
    content: <span className="font-md text-light-weight grey-500">You have unsaved changes that will be lost if you leave.</span>,
    okText: <span className="font-md text-light-weight text-white">Stay on Page</span>,
    cancelText: <span className="font-md text-light-weight grey-900">Leave & Discard Changes</span>,
    onCancel() {
      backToPurchaseOrder(isNavigatingRef, history, module);
    },
    okButtonProps: { className: "po-leave-confirm-ok-btn" },
    cancelButtonProps: { className: "po-leave-confirm-cancel-btn" },
  });
};
export const renderSupplierInvoices = (invoices) => {
  const filtered = invoices?.filter((e) => e !== "") || [];
  return filtered.length > 0
    ? filtered.map((e, i) => (
        <span key={i}>
          {e}
          {i < filtered.length - 1 ? ", " : ""}
        </span>
      ))
    : "--";
};
export function clearBackgroundTask() {
  let backgroundTasksKey = [
    "BEstatus",
    "BEid",
    "categoryExportToken",
    "categoryExportId",
    "categoryImportToken",
    "PEid",
    "productExportTaskId",
    "StockId",
    "stockToken",
    "supplierImportToken",
    "supplierExportId",
    "supplierPaymentListId",
    "customerExportId",
    "customerImportToken",
    "customerExportTaskId",
    "printLedgerId",
    "paymentListId",
    "rapReportExportTaskId",
    "calCigReportExportTaskId",
    "kentuckyReportExportTaskId",
    "kctReportExportTaskId",
    "rcrReportExportTaskId",
    "ldrReportExportTaskId",
    "profitMarginReportExportTaskId",
    "profitMarginCashBasisReportExportTaskId",
    "supplierPaymentLogReportExportTaskId",
    "dayWiseReportExportTaskId",
    "invoiceHistoryExportTaskId",
    "agingReportExportTaskId",
    "saleCommissionReportExportTaskId",
    "paymentLogReportExportTaskId",
    "paymentReceivedReportExportTaskId",
    "accountPayableReportExportTaskId",
    "accountReceivableReportExportTaskId",
    "invenAdjustReportExportTaskId",
    "backOrderReportExportTaskId",
    "onHoldReportExportTaskId",
    "PartiallyFulfilledReportExportTaskId",
    "inventorySpotCheckReportExportTaskId",
    "inventoryEvaluationReportExportTaskId",
    "poTaxReportExportTaskId",
    "supplierPOReportExportTaskId",
    "purchaseOrderHistoryExportTaskId",
    "customerPerformanceReportExportTaskId",
    "lostSaleExportTaskId",
    "saleRepBrandExportTaskId",
    "saleRepProductExportTaskId",
    "saleRepCategoryExportTaskId",
    "velocityReportTaskId",
    "countyExportTaskId",
    "itemVelocityReportExportTaskId",
    "itemDetailExportTaskId",
    "customerBrandVelocityExportTaskId",
    "brandPriceExportTaskId",
    "saleSumExportTaskId",
    "customerCategorySalesExportTaskId",
    "customerCategoryVelocityExportTaskId",
    "catPriceExportTaskId",
    "productImportToken",
    "stockImportToken",
    "PrintLabelKey",
    "MSA_ID",
    "msaParserTaskId",
    "packListId",
    "pickListId",
    "edi",
    "excel-export-edi",
    "pdf-export-edi"
  ];
  backgroundTasksKey.forEach((key) => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    }
  });
}
export const getSocketUrl = () => {
  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  const host = window.location.host;
  return `${protocol}://${host}`;
};
export function generateUUID() {
  return uuidv4();
}
export const styles = `
@media print {
 .invoice-summary-details{
  margin-top:60px;
}
  .pdf-body,
  .pdf-body.print-container-only {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    overflow: visible !important;
    background: #fff !important;
  }
  .invoice-body {
    width: 100% !important;
    max-width: 100% !important;
    overflow: visible !important;
    background: #fff !important;
  }
  .sale-invoice-responsive {
    width: 100% !important;
    max-width: 100% !important;
    overflow: visible !important;
  }
  .sale-invoice-responsive .hide-invoice-table {
    display: table !important;
  }
  .sale-invoice-responsive .hide-invoice-card {
    display: none !important;
  }
  .sale-invoice-responsive .items-table {
    width: 100% !important;
    overflow: visible !important;
  }
  .sale-invoice-responsive .table-size {
    width: 100% !important;
  }
  @page {
    size: A4;
       margin: 10mm 5mm 20mm 5mm !important;
        width: 100% !important;
        @bottom-left {
          content: "Powered by Kommerce Hub";
          font-size: 9px;
          color: #666;
          margin-left: 5mm;
        }
        @bottom-right {
          content: counter(page) " / " counter(pages);
          font-size: 9px;
          color: #666;
          margin-right: 5mm;
        }
  }
  .footerOrderNo {
        position: fixed;
        left: 18px;
        bottom: 0;
        margin-bottom: 0px;
        padding-bottom: 0px;
        z-index: 1000;
      }
    .message-body{
      width:380px
    }
    }
 .invoice-body{
  font-size:15px !important;
  line-height:24px;
  font-family:'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
  background-color: white;
  padding-top: 10px;
  height: 100%;
  counter-reset: page;
}
.pdf-body{
  background-color: white;
  margin-right: 16px;
  margin-left: 16px;
}
.font-right{
  text-align:right;
}
@media print {
  margin-bottom: 20cm;
}
@media print {
  .qr-flex {
    margin-left: 100px;
  }
}
@media print {
  .back-order-row {
    background-color: white;
  }
}
@media screen {
  .back-order-row.pink-background {
    background-color: rgb(239 213 237);
  }
  .back-order-row.white-background {
    background-color: white;
  }
}
.print-friendly{
  table.print-friendly tr td, table.print-friendly tr th {
    break-inside: avoid;
}
}
.subheading {
  font-weight: bold;
  font-size: 14px;
}
.second-subheading {
  font-weight: bold;
  font-size: 17px;
}
.text {
  font-size: 14px;
}
.product-text {
  font-size: 17px;
}
.product-text-2 {
  font-size: 17px;
}
@media only screen and (max-width: 1920px) {
  .qr-flex {
    margin-left: 60px;
  }
}
@media only screen and (max-width: 1440px) {
  .qr-flex {
    margin-left: 60px;
    }
}
@media only screen and (max-width: 1024px) {
  .qr-flex {
    margin-left: 100px;
  }
}
@media only screen and (max-width: 990px) {
  .scan-to-pay-column {
    padding-left: 12px;
    padding-right: 12px;
    margin-left: 62px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .scan-to-pay-column {
    padding-left: 12px;
    padding-right: 12px;
    margin-left: -240px;
    margin-bottom: 30px;  
  }
    .invoice-logo {
    margin-bottom: 12px;
  }
}
@media only screen and (max-width: 668px) {
  .scan-to-pay-column {
    margin-left: -195px;  
  }
  .invoice-logo {
    margin-bottom: 12px;
  }
}
@media only screen and (max-width: 430px) {
  .product-text {
    font-size: 11px;
  }
  .second-subheading {
    font-weight: bold;
    font-size: 11px;
  }
  .invoice-body{
    font-size:11px !important;
    line-height:20px;
  }
  .ant-card-body {
    padding: 0px;
}
  .product-text-2 {
    font-size: 11px;
    width:100%
  }
  .qr-flex { 
    margin-left: 0px
  }
}
@media screen and (max-width: 767px) {
  .pdf-body {
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 0 12px 16px !important;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  .invoice-body {
    max-width: 100%;
    padding: 0 !important;
    overflow-x: hidden;
    -webkit-text-size-adjust: 100%;
  }
  .invoice-body .container,
  .invoice-body .container-fluid {
    max-width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .sale-invoice-responsive {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    color: #465062;
  }
  .sale-invoice-responsive * {
    box-sizing: border-box;
  }
  .sale-invoice-responsive .invoice-card {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 0 10px !important;
    padding: 12px !important;
    border: 1px solid #edf1f7;
    border-radius: 8px;
    background: #fff;
  }
  .sale-invoice-responsive .invoice-card > [class*="ant-col"],
  .sale-invoice-responsive .invoice-card [class*="ant-col-"] {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .sale-invoice-responsive .invoice-logo {
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 0 8px !important;
  }
  .sale-invoice-responsive .logo-save-invoice {
    width: 128px !important;
    height: 64px !important;
    margin: 0 auto 8px !important;
    background-position: center;
  }
  .sale-invoice-responsive .qr-flex {
    display: flex !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    margin-left: 0 !important;
  }
  .sale-invoice-responsive .tenant-invoice-details {
    width: 100% !important;
    max-width: 100%;
    line-height: 1.45;
  }
  .sale-invoice-responsive .tenant-invoice-details p,
  .sale-invoice-responsive .tenant-invoice-details h1,
  .sale-invoice-responsive .tenant-invoice-details h2,
  .sale-invoice-responsive .tenant-invoice-details h3 {
    margin: 0 0 2px;
  }
  .sale-invoice-responsive .hide-qr-main {
    display: flex !important;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    margin-top: 2px;
  }
  .sale-invoice-responsive .hide-qr-main svg {
    width: 132px !important;
    height: 132px !important;
    max-width: 45vw !important;
  }
  .sale-invoice-responsive .scan-to-pay-column {
    display: none !important;
  }
  .sale-invoice-responsive table {
    max-width: 100%;
  }
  .sale-invoice-responsive .invoice-card table,
  .sale-invoice-responsive .invoice-card .table-size {
    width: 100% !important;
  }
  .sale-invoice-responsive .invoice-card table tr {
    display: grid;
    grid-template-columns: minmax(96px, 38%) minmax(0, 1fr);
    column-gap: 10px;
    align-items: start;
    padding: 2px 0;
  }
  .sale-invoice-responsive .invoice-card table tr td {
    min-width: 0;
    width: auto !important;
    word-break: break-word;
  }
  .sale-invoice-responsive .invoice-card table tr td:only-child {
    grid-column: 1 / -1;
  }
  .sale-invoice-responsive .invoice-heading {
    font-size: 13px !important;
    margin-top: 4px;
  }
  .sale-invoice-responsive .second-subheading,
  .sale-invoice-responsive .product-text,
  .sale-invoice-responsive .product-text-2,
  .sale-invoice-responsive .text {
    font-size: 12px !important;
    line-height: 1.45;
  }
  .sale-invoice-responsive .products.center-img {
    display: block;
    justify-items: initial;
  }
  .sale-invoice-responsive .hide-invoice-table {
    display: none !important;
  }
  .sale-invoice-responsive .hide-invoice-card {
    display: block !important;
    width: 100% !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-row {
    display: block !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .sale-invoice-responsive .hide-invoice-card [class*="ant-col-"] {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-bottom: 10px;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0;
    overflow: visible;
    border-radius: 8px !important;
    box-shadow: 0 1px 4px rgba(24, 39, 75, 0.12) !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body {
    padding: 10px !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div {
    display: grid !important;
    grid-template-columns: 64px minmax(0, 1fr);
    column-gap: 10px;
    align-items: start;
    width: 100%;
    max-width: 100%;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:first-child {
    width: 64px !important;
    margin-right: 0 !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:only-child {
    grid-column: 1 / -1;
    width: 100% !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:last-child {
    display: block !important;
    min-width: 0;
    width: 100%;
    max-width: 100%;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:last-child > div:first-child {
    width: 100%;
    max-width: 100%;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:last-child > div:first-child > p {
    margin: 0 0 6px !important;
    line-height: 1.25 !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:last-child > div:first-child > div {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 2px 8px;
    justify-content: normal !important;
    width: 100%;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:last-child > div:first-child > div > div {
    min-width: 0;
    width: 100%;
    line-height: 1.25 !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body p {
    margin-bottom: 4px !important;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.3 !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:last-child > div:nth-child(2) {
    width: 100% !important;
    max-width: 180px;
    margin-top: 4px;
    overflow: hidden;
  }
  .sale-invoice-responsive .hide-invoice-card img {
    max-width: 64px !important;
    width: 64px !important;
    height: auto !important;
  }
  .sale-invoice-responsive .hide-invoice-card svg {
    max-width: 100%;
  }
  .sale-invoice-responsive .items-table:not(.hide-invoice-table) {
    display: block;
    width: 100% !important;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .sale-invoice-responsive .invoice-summary-details,
  .sale-invoice-responsive .invoice-summary-details > tbody,
  .sale-invoice-responsive .invoice-summary-details > tbody > tr,
  .sale-invoice-responsive .invoice-summary-details > tbody > tr > td {
    display: block;
    width: 100% !important;
  }
  .sale-invoice-responsive .invoice-summary-details .row,
  .sale-invoice-responsive .invoice-summary-details .ant-row {
    display: block;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .sale-invoice-responsive .invoice-summary-details [class*="col-"],
  .sale-invoice-responsive .invoice-summary-details [class*="ant-col-"] {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .sale-invoice-responsive .invoice-summary-details table {
    width: 100% !important;
  }
  .sale-invoice-responsive .message-body {
    width: 100% !important;
  }
  .sale-invoice-responsive .bg-image {
    display: none;
  }
}
@media screen and (max-width: 380px) {
  .sale-invoice-responsive .hide-qr-main svg {
    width: 116px !important;
    height: 116px !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body {
    padding: 9px !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div {
    grid-template-columns: 56px minmax(0, 1fr);
    column-gap: 8px;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body > div > div:first-child {
    width: 56px !important;
  }
  .sale-invoice-responsive .hide-invoice-card img {
    max-width: 56px !important;
    width: 56px !important;
  }
  .sale-invoice-responsive .hide-invoice-card .ant-card-body p {
    font-size: 9px !important;
  }
  .sale-invoice-responsive .invoice-card table tr {
    grid-template-columns: minmax(86px, 40%) minmax(0, 1fr);
  }
}
@supports (-webkit-touch-callout: none) {
  @media screen and (max-width: 767px) {
    .pdf-body {
      padding-left: max(12px, env(safe-area-inset-left)) !important;
      padding-right: max(12px, env(safe-area-inset-right)) !important;
    }
  }
}
.billing-col{
  margin-right: 10px;
}
.shipping-col{
  margin-left: 10px;
}
.heading{
  font-weight:bold;
  font-size: 14px;
  text-transform: uppercase;
}
.heading-title{
  font-weight:bold;
  font-size: 24px;
  text-transform: uppercase;
}
.hr-line{
  margin-bottom: 3px !important;
  border-bottom: 1px groove;
  opacity: 50%;
}
.hr{
  border-bottom: 1px solid black;
  margin-bottom: 5px !important;
}
.products{
  margin: 20px 0px;
}
.text-right{
  text-align: right !important;
}
.table-size{
  width:100%;
}
.border-product td{
  border: 2px solid #bcc1c5 !important;
  // text-align:center ;
  padding-left:2px;
}
.border-product th{
  // text-align:center;
}
.cat-size{
  font-size: 19px !important;
}
.view-width-30{
  max-width:30vw;
}
.table-product-name-size{
  // width:10%;
  padding-right:10px;
}
}
.table-name-col{
  text-align:left;
}
.bg-image-products{
height: 200px;
width: 400px;
background-size: contain;
background-repeat: no-repeat;
opacity: 0.4;
position: absolute;
z-index: 2;
margin-left: 0%;
pointer-events: none;
}
.bg-image{
  height: 200px;
  width: 500px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.4;
  position: absolute;
  z-index: 2;
  pointer-events: none;
  }
  .bg-image-center-with-header{
    margin-top: 16%;
  }
  .bg-image-center-no-header{
  margin-top: 8%;
  }
  .bg-return-image-center{
    height: 200px;
    width: 500px;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.4;
    position: absolute;
    z-index: 2;
    margin-top: 16%;
    pointer-events: none;
    }
  .bg-image-top{
    height: 200px;
    width: 400px;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.4;
    position: absolute;
    z-index: 2;
    margin-top: 0%;
    pointer-events: none;
    }
    .bg-image-bottom{
      height: 200px;
      width: 400px;
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 0.4;
      position: absolute;
      z-index: 2;
      margin-left: 30%;
      pointer-events: none;
      }
 .height{
  min-height: 200px;
  position: relative;
  justify-items: center;
  display: grid;
  align-items: center;
}
 .center-img{
  position: relative;
  justify-items: center;
  display: grid;
}
.k-pdf-export p{
  font-size: 1.5rem !important;
  font-weight: bold;import { notification } from 'antd';
}
.tenant-invoice-details p, .tenant-invoice-details h1, .tenant-invoice-details h2, .tenant-invoice-details h3{ 
  margin-bottom: 0px;
  word-wrap: break-word; 
  white-space: normal; 
  overflow-wrap: break-word
}
  .address-email{
  width: 100%;
  margin-bottom: 0px;
  white-space: normal; 
  overflow-wrap: break-word;
  word-break: break-word;
  }
.heading-box{
  border: black 2px solid;
  border-radius: 3px;
  padding-left: 10px;
  padding-right: 10px;
}
.scan-to-pay {
  text-align: center;
  margin-left: -10px;
}
`;
export const uploadFileToCloud = async (file, path = "media/product/files", options = {}) => {
  const { maxSize = 5242880, onProgress } = options;
  // Validate file size
  if (file.size > maxSize) {
    throw new Error(`File size must be less than ${Math.round(maxSize / 1024 / 1024)}MB`);
  }
  // Generate unique file ID and sanitize filename
  const fileId = uuidv4();
  const fileName = parseSpecialChr(file.name);
  const filePath = `${path}/${fileId}/${fileName}`;
  try {
    // Get presigned URL
    const { getPresignedUrlCategory, uploadFileToCloudCategory } = await import("../Catalog/_redux/products/productsCrud");
    const presignedResponse = await getPresignedUrlCategory(filePath);
    const { data } = presignedResponse;
    // Upload file to cloud
    const uploadResponse = await uploadFileToCloudCategory({
      url: data[0].url,
      file: file,
    });
    // Return uploaded file object
    const uploadedFile = {
      id: fileId,
      url: uploadResponse?.url?.split("?")[0] || "",
      name: file.name,
      size: file.size,
      type: file.type,
    };
    return uploadedFile;
  } catch (error) {
    throw new Error(`File upload failed: ${error.message}`);
  }
};
export const uploadMultipleFilesToCloud = async (files, path = "media/product/files", options = {}) => {
  const uploadPromises = files.map((file) => uploadFileToCloud(file, path, options));
  return Promise.all(uploadPromises);
};
export const validateFile = (file, options = {}) => {
  const { maxSize = 5242880, allowedTypes = [], maxFiles = 1 } = options;
  if (file.size > maxSize) {
    return {
      isValid: false,
      error: `File size must be less than ${Math.round(maxSize / 1024 / 1024)}MB`,
    };
  }
  if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) {
    return {
      isValid: false,
      error: `File type ${file.type} is not allowed. Allowed types: ${allowedTypes.join(", ")}`,
    };
  }
  return { isValid: true, error: null };
};
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
export const truncateFileName = (name, maxLength = 30) => {
  if (!name) return "";
  if (name.length <= maxLength) return name;
  return name.substring(0, maxLength) + "...";
};
export const getFileNameFromUrl = (url) => {
  if (!url) return "";
  return url.split("/").pop();
};
export const getTokenLocalStorage = () => {
  try {
    const persist = JSON.parse(localStorage.getItem("persist:demo1-auth") || "{}");
    return JSON.parse(persist.authToken || '""');
  } catch {
    return null;
  }
};
export const PRODUCT_STATUS_OPTIONS = [
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
  { value: 3, label: "Archived" },
];
export const InvoiceWrapper = ({ children }) => {
  return (
    <div>
      <div style={{ display: "none" }}>
        <style dangerouslySetInnerHTML={{ __html: styles }} />
      </div>
      <div className="invoice-body">{children}</div>
    </div>
  );
};
// Customer Creation Form validation Message
// Helper function to get field name mapping for better error messages
export const getFieldDisplayName = (fieldName) => {
  const fieldMapping = {
    name: "Name",
    email: "Email",
    phone_no: "Phone Number",
    business_name: "Business Name",
    business_phone_no: "Business Phone Number",
    is_exempt_from_tax: "Tax Preference",
    password: "Password",
    tier_id: "Tier",
    business_tax_no: "Business Tax Number",
    date_of_join: "Date of Joining",
    balance_limit_check: "Balance Limit Check",
    invoice_aging: "Invoice Aging",
    invoice_custom_aging: "Custom Invoice Aging",
    balance_limit: "Customer Credit Limit",
    class_of_trades: "Class of Trades",
    "customer_shipping_details.name": "Shipping Name",
    "customer_shipping_details.company_name": "Shipping Company Name",
    "customer_shipping_details.address": "Shipping Address",
    "customer_shipping_details.address_line_1": "Shipping Address Line 2",
    "customer_shipping_details.city": "Shipping City",
    "customer_shipping_details.state": "Shipping State",
    "customer_shipping_details.country": "Shipping Country",
    "customer_shipping_details.zip_code": "Shipping Zip Code",
    "customer_shipping_details.tax_jurisdiction": "Shipping Tax Jurisdiction",
    "customer_billing_details.name": "Billing Name",
    "customer_billing_details.company_name": "Billing Company Name",
    "customer_billing_details.address": "Billing Address",
    "customer_billing_details.address_line_1": "Billing Address Line 2",
    "customer_billing_details.city": "Billing City",
    "customer_billing_details.state": "Billing State",
    "customer_billing_details.country": "Billing Country",
    "customer_billing_details.zip_code": "Billing Zip Code",
  };
  return fieldMapping[fieldName] || fieldName;
};
// Helper function to find the first error field and determine which step it belongs to
export const findFirstErrorAndStep = (errors) => {
  const flattenErrors = (obj, prefix = "") => {
    let result = [];
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
          result = result.concat(flattenErrors(obj[key], fullKey));
        } else if (obj[key]) {
          result.push({ field: fullKey, error: obj[key] });
        }
      }
    }
    return result;
  };
  const flatErrors = flattenErrors(errors);
  if (flatErrors.length === 0) return null;
  const firstError = flatErrors[0];
  // Determine which step the error belongs to
  let targetStep = 0;
  if (firstError.field.startsWith("customer_shipping_details") || firstError.field.startsWith("customer_billing_details")) {
    targetStep = 1;
  }
  return {
    field: firstError.field,
    error: firstError.error,
    step: targetStep,
    displayName: getFieldDisplayName(firstError.field),
  };
};
// Helper function to scroll to the first error field
export const scrollToField = (fieldName) => {
  setTimeout(() => {
    // Convert field name to a selector-friendly format
    let selector = `[name="${fieldName}"]`;
    // Try different selector patterns
    const selectors = [
      `[name="${fieldName}"]`,
      `#${fieldName}`,
      `.field-${fieldName}`,
      `[data-field="${fieldName}"]`,
      // For nested fields, try without the parent object
      fieldName.includes(".") ? `[name="${fieldName.split(".").pop()}"]` : null,
    ].filter(Boolean);
    let element = null;
    for (const sel of selectors) {
      element = document.querySelector(sel);
      if (element) break;
    }
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      // Focus the field if it's focusable
      if (element.focus) {
        element.focus();
      }
      // Add a highlight effect
      element.style.boxShadow = "0 0 5px #ff4d4f";
      setTimeout(() => {
        element.style.boxShadow = "";
      }, 3000);
    }
  }, 100);
};
const scanableFieldIds = ["productSearchInput", "searchTextCtrlQ"];
const scanKeyQue = [];
const processScanQueue = () => {
  console.log("scanKeyQue");
  const activeElement = document.activeElement;
  if (scanableFieldIds.includes(activeElement.id)) {
    scan(scanKeyQue.shift());
  }
  console.log("scanKeyQue.length", scanKeyQue.length);
  if (scanKeyQue.length > 0) {
    setTimeout(() => {
      processScanQueue();
    }, 1001);
  }
};
async function scan(scan_key) {
  const activeElement = document.activeElement;
  console.log("activeElement:", activeElement);
  if (!activeElement) {
    notification.warning({ message: "Scanned value discarded, as you haven't focused on any input field" });
    return;
  } else if (!scanableFieldIds.includes(activeElement.id) || activeElement.value) {
    console.log("scanableFieldIds", scanableFieldIds);
    scanKeyQue.push(scan_key);
    console.log(scan_key);
    if (scanKeyQue.length === 1) {
      // Start processing the queue
      setTimeout(() => {
        processScanQueue();
      }, 1001);
    }
    return;
  }
  activeElement.value = scan_key;
  try {
    const enterEventKeyDown = new KeyboardEvent("keydown", {
      key: "Enter",
      code: "Enter",
      charCode: 13,
      keyCode: 13,
      which: 13,
      bubbles: true,
      cancelable: true,
    });
    activeElement.dispatchEvent(enterEventKeyDown);
    // await dispatch(activeElement, enterEventKeyDown);
  } catch (err) {
    console.error("Error dispatching keydown event:", err);
  }
}
export function onScannedProducts(scan_keys, start = 0) {
  const isProductSearchInputFocused = document.getElementById("productSearchInput") === document.activeElement;
  const isSearchTextCtrlQFocused = document.getElementById("searchTextCtrlQ") === document.activeElement;
  if(!isProductSearchInputFocused && !isSearchTextCtrlQFocused){ 
    return
  }
  if (start >= scan_keys.length) {
    console.log("✅ All items scanned. Total:", scan_keys.length);
    return;
  }
  scan(scan_keys[start]).then(() => {
    setTimeout(() => {
      onScannedProducts(scan_keys, start + 1);
    }, 100);
  });
}
export function groupAccountsByType(accounts) {
  return (
    accounts?.reduce((acc, account) => {
      const typeName = account.account_type_name || "Other";
      if (!acc[typeName]) acc[typeName] = [];
      acc[typeName].push(account);
      return acc;
    }, {}) || {}
  );
}
export function sortAccountGroups(groupedAccounts) {
  if (!groupedAccounts) return [];
  const priority = ["Expenses", "Assets"];
  return Object.keys(groupedAccounts).sort((a, b) => {
    const aPriority = priority.indexOf(a);
    const bPriority = priority.indexOf(b);
    if (aPriority > -1 && bPriority > -1) {
      return aPriority - bPriority;
    }
    if (aPriority > -1) return -1;
    if (bPriority > -1) return 1;
    return a.localeCompare(b);
  });
}

export const getAccountInstitutionName = (account) => account?.plaid_institution_name || account?.institution_name || "";

// "Bank of America - Plaid Checking ••0000" — same identity shown on the Banking screen's
// account cards (institution name, Plaid account name, masked account number), for anything
// carrying those fields (a Plaid transaction row, a linked bank account, etc).
export const getPlaidAccountDisplayLabel = (account) => {
  const institutionName = getAccountInstitutionName(account);
  const accountName = account?.plaid_account_name || account?.account_name || account?.name || "";
  const parts = [institutionName, accountName].filter(Boolean);
  const label = parts.join(" - ");
  const mask = account?.mask || "";
  return mask ? `${label ? `${label} ` : ""}••${mask}` : label;
};

export const getAccountNameWithNumber = (account) => {
  if (account?.account_type_name !== "Bank" || !account?.account_number) {
    return account?.name;
  }

  const accountNumberLastFour = String(account.account_number).replace(/\D/g, "").slice(-4);
  return accountNumberLastFour ? `${account.name} (${accountNumberLastFour})` : account.name;
};

export const renderAccountNameWithInstitution = (account) => {
  const institutionName = getAccountInstitutionName(account);

  return (
    <div>
      <div>{account?.name}</div>
      {institutionName ? (
        <div style={{ color: "#8c8c8c", fontSize: "14px", lineHeight: "16px" }}>
          {institutionName}
        </div>
      ) : null}
    </div>
  );
};

export const ChannelNameColumnFormatter = (channel_name) => <span>{channel_name || "N/A"}</span>;
export const ChannelNameColumnFormatterForAgridTable = (channel) => {
  return channel?.value || "N/A";
};
export const secondsToDHMS = (totalSeconds) => {
  if(!totalSeconds || totalSeconds < 0) {
    return "0d 0h 0m 0s";
  }
  const safeTotalSeconds = Math.floor(Math.max(0, Number(totalSeconds) || 0));
  const days = Math.floor(safeTotalSeconds / (24 * 60 * 60));
  const hours = Math.floor((safeTotalSeconds % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((safeTotalSeconds % (60 * 60)) / 60);
  const seconds = safeTotalSeconds % 60;
  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
}
export const metersToMiles = (meters) => (meters * 0.000621371).toFixed(2);

export const DeliveryRouteNumberColumnFormatter = (delivery_route) => <span>{delivery_route?.no || "N/A"}</span>;

const isUPCAlreadyExist = (values, isUPCExist, Modal, ExclamationCircleOutlined) => {
    isUPCExist(values.upc).then((res) => {
      if (res?.data?.message) {
        const productNamesList = res?.data?.product_data
          ?.filter((product) => values?.id != product.id)
          ?.map((product) => (
            <div
              key={product.id}
              onClick={() => window.open(`/catalog/products/${product.id}/edit`)}
              style={{
                cursor: 'pointer',
                fontWeight: '600',
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
                width: '50%'
              }}
            >
              <div>• {product.name}</div>
              <div>{product.UPC}</div>
            </div>
          ));

        Modal.confirm({
          title: "Info",
          icon: <ExclamationCircleOutlined />,
          content: (
            <>
              <p>UPC already exists in the system.</p>
              {productNamesList}
            </>
          ),
          cancelText: "Close",
          okButtonProps: {
            disabled: true,
            hidden: true
          }
        });
      }
    });
  };

  export const checkImageAndUPCExisted = async (
    values,
    upcOptions,
    isUPCExist,
    getImage,
    Modal,
    ExclamationCircleOutlined,
    setFieldValue,
    setImageLoading
  ) => {
    isUPCAlreadyExist(values, isUPCExist, Modal, ExclamationCircleOutlined)
    try {
      if (values.auto_fetch_img) {
        setImageLoading?.(true);
        const response = await getImage({ product_upc: values.upc });
        const { image_url } = response.data;
        if (response.data.image_url != null && response.status == 200) {
          notification.success({ message: "Fetching images for you.", duration: 3 });
        } else if (response.data.image_url == null) {
          notification.error({ message: "Image not found, please upload manually.", duration: 3 });
        }
        if (image_url) {
          const images = values.images || [];
          const imagesSeo = values.images_seo || [];
          const nonUPCImage = images.length > 0 && upcOptions?.find((option) => image_url.split("/upc/")[1] === option);
          setFieldValue?.("images_seo", [...imagesSeo, { url: image_url, alt_text: "" }]);
          !nonUPCImage && setFieldValue?.("default_image_seo", { url: image_url, alt_text: "" });
          setFieldValue?.("images", [...images, image_url]);
          !nonUPCImage && setFieldValue?.("default_image", image_url);
        }
      }
    } catch (err) {
    } finally {
      setImageLoading?.(false);
    }
  };

export const navigateToInvoiceHistoryByOverduePeriod = (history) => {
  history.push("/reporting/financial-reporting/aging-report");
};

export function notifyDeliveryChargeWarning(data) {
  if (data?.delivery_charge_warning) {
    notification.warning({ message: data.delivery_charge_warning });
  }
}
